/* eslint-disable react/prop-types */
"use client";

import React from "react";
import { useTranslation } from "react-i18next";
import AppModalShell, {
  AppModalButton,
  AppModalContentItem,
} from "../common/AppModalShell";
import ChatNotificationBellIcon from "./ChatNotificationBellIcon";

export default function ClubChatNotificationsModal({
  visible = false,
  muted = false,
  submitting = false,
  desktopMountNode = null,
  onClose = () => {},
  onConfirm = () => {},
}) {
  const { t } = useTranslation("menu");
  const copyBase = "chats.notifications";

  return (
    <AppModalShell
      open={visible}
      title={muted ? t(`${copyBase}.enable_title`) : t(`${copyBase}.disable_title`)}
      description={muted ? t(`${copyBase}.enable_description`) : t(`${copyBase}.disable_description`)}
      desktopMountNode={desktopMountNode}
      onClose={onClose}
      closeAriaLabel={t(`${copyBase}.close_aria`)}
      maxWidthClassName="max-w-[35rem]"
      panelClassName="border-white/64"
      bodyClassName="px-5 pb-5"
    >
      <AppModalContentItem className="mb-5 flex justify-center">
        <div className="flex h-[74px] w-[74px] items-center justify-center rounded-full border border-white/14 bg-white/[0.08] text-white shadow-[inset_0_1px_0_rgba(255,255,255,0.06)]">
          <ChatNotificationBellIcon muted={!muted} size={36} />
        </div>
      </AppModalContentItem>

      <AppModalContentItem className="grid grid-cols-1 gap-3">
        <AppModalButton
          variant={muted ? "primary" : "danger"}
          onClick={onConfirm}
          disabled={submitting}
          loading={submitting}
        >
          {submitting
            ? t(`${copyBase}.saving`)
            : muted
              ? t(`${copyBase}.enable_confirm`)
              : t(`${copyBase}.disable_confirm`)}
        </AppModalButton>
        <AppModalButton
          variant="secondary"
          onClick={onClose}
          disabled={submitting}
        >
          {t(`${copyBase}.cancel`)}
        </AppModalButton>
      </AppModalContentItem>
    </AppModalShell>
  );
}
